import React from 'react';
import WikiLayout from '../components/Wiki/WikiLayout';

const Wiki = () => {
  return <WikiLayout />;
};

export default Wiki;
